import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiDraftReminderSMS(customerName: string, serviceName: string, startISO: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are an SMS copywriter for small local businesses. Write 3 short reminder SMS variants (under 160 chars each) reminding the customer of their upcoming appointment. Warm, professional, brand-neutral. Number each variant.`;
  try {
    await streamGroq({
      messages: [{ role: 'system', content: system }, { role: 'user', content: `Customer: ${customerName}\nService: ${serviceName}\nTime: ${new Date(startISO).toLocaleString()}` }],
      temperature: 0.5, onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The booking tools work fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
